module.exports = __webpack_public_path__ + "menu-in.9104a74537046ce4b8c897b821d04ea6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-in.svg
// module id = 1143
// module chunks = 0